export const CHAT_MODEL_STORAGE_KEY = 'hashely_canvas_chat_model';
export const CHAT_MODEL_CHANGE_EVENT = 'hashely:chat-model-change';

export const CHAT_MODEL_IDS = ['fast', 'better', 'pro'];
export const DEFAULT_CHAT_MODEL = 'better';

export function isValidChatModel(model) {
  return CHAT_MODEL_IDS.includes(model);
}

export function normalizeChatModel(model) {
  const input = String(model || '').trim().toLowerCase();
  if (isValidChatModel(input)) return input;
  return DEFAULT_CHAT_MODEL;
}

export function readChatModel() {
  try {
    return normalizeChatModel(window.localStorage?.getItem(CHAT_MODEL_STORAGE_KEY));
  } catch {
    return DEFAULT_CHAT_MODEL;
  }
}

export function writeChatModel(model) {
  const normalized = normalizeChatModel(model);
  try {
    window.localStorage?.setItem(CHAT_MODEL_STORAGE_KEY, normalized);
  } catch {
    // ignore storage errors
  }
  return normalized;
}

export function dispatchChatModelChange(model) {
  try {
    window.dispatchEvent(
      new CustomEvent(CHAT_MODEL_CHANGE_EVENT, {
        detail: { model: normalizeChatModel(model) },
      })
    );
  } catch {
    // ignore
  }
}
